export default import.meta.ROLLUP_FILE_URL_P0LNqp0qXKm07LMW8D5BnA